import type { DocMigration } from "../docMigration";

function migrateViewFilter(viewFilter: any) {
  if (viewFilter?.patios !== undefined) {
    delete viewFilter.patios;
  }
  if (viewFilter?.interiorStaircases !== undefined) {
    delete viewFilter.interiorStaircases;
  }
  if (viewFilter?.exteriorStaircases !== undefined) {
    delete viewFilter.exteriorStaircases;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_499: DocMigration = {
  maxSchemaVersion: "0.0.499",
  // These categories were dead code at the time of this migration.
  description: "Remove patios, interiorStaircases, and exteriorStaircases from stored view filter",
  apply(json: any): any {
    const view3Ds = json.view3Ds ?? {};
    for (const id in view3Ds) {
      const view3D = view3Ds[id];
      migrateViewFilter(view3D.viewFilter);
    }
    json.view3Ds = view3Ds;

    const planViews = json.planViews ?? {};
    for (const id in planViews) {
      const planView = planViews[id];
      migrateViewFilter(planView.viewFilter);
    }
    json.planViews = planViews;
    return json;
  },
};

export default migration_0_0_499;
